import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { SwiperContainer } from './SwiperContainer';
import { ListContainer } from './ListContainer';
import { BannerAd } from '../../js/ComponentManager';
/* 개발담당:양유빈
 * 화면기능:상품 리스트들의 컨테이너
 * 세부설명:
*/

export class HomeGoodsContainer extends Component {
    static displayName = HomeGoodsContainer.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr_List: []
        };
        
    }
    //초기화
    async componentDidMount () {
        try {

            const Data = await Big3Common.Get('api/AdMgr/HomeAd/GetContentConmgr/MA');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const ContentConmgr_List = JSON.parse(Data.dataTable);              
                this.setState({
                    ContentConmgr_List: ContentConmgr_List
                }) 
            }
            else {
                console.log(Data.message);
            }
            //로그 기록
            Big3Common.RegisterTrackingLog({
                [Big3Common.ContentState.Page_cd]: "MP",
                [Big3Common.ContentState.Basket_Yn]: "N"
            });
        }
        catch (e) {
            console.log("componentDidMount", e);
        }
    }
 
    //UI 유형 설정 ==> 스와이프(SW) or 리스트(LS)
    UIType_render(list, mgr_no, index, ListCount) {
        const ui_tye = list.ui_tye;       
       
        if (ui_tye === "SW") {
            return (
                <SwiperContainer
                    key={`${mgr_no}_${index}`}
                    data-info={list}
                    index={index}
                    GoodsDtlShow={this.props.GoodsDtlShow}
                />
            )
        }
        else if (ui_tye ==="LS") {
            return (
                <ListContainer
                    key={`${mgr_no}_${index}`}
                    data-info={list}
                    index={index} 
                    listcount={ListCount}
                    GoodsDtlShow={this.props.GoodsDtlShow}
                />
            )
        }
        else {
            return (
                "컨텐츠준비중입니다."
            )
        }
    }
    Banner_render(index, ListCount) {

        if (index < ListCount - 1 && index === 3) {
            return (
                <BannerAd id="HomeCBanner" ads_loc_cd="H2" />
            )
        }
        else {
            return false;
        }
    }
    render() {
        const ContentConmgr_List = this.state.ContentConmgr_List;
        const ListCount = ContentConmgr_List.length;
        if (ContentConmgr_List.length === 0) return;
        return (
            <>
                {ContentConmgr_List.map((list, index) => (
                    <div key={`${list.mgr_no}_${index}`}>
                        {this.Banner_render(index, ListCount) }
                        {this.UIType_render(list, list.mgr_no, index, ListCount)}
                    </div>
                ))}

            </>
        )
    }
}
